import EventActionProto from '../../event-action-proto';

module.exports = class SessionMyWorkChangeSortPositions extends EventActionProto {

    constructor(uid, data, fromSID) {
        super(uid, data);

        this.fromSID = fromSID;
    }

    process() {
        if (gd.session.myWorkSortPositions) {
            _.mapKeys(this.data, (value,key)=>{
                gd.session.myWorkSortPositions[key] = value;
            })

            gd.bus.triggerEvent('gd.session.myWorkSortPositions:changed', _.keys(this.data));
        }
    }
};